import { render } from "./Section.vue?vue&type=template&id=2d84a836&scoped=true"
import script from "./Section.vue?vue&type=script&lang=js"
export * from "./Section.vue?vue&type=script&lang=js"

import "./Section.vue?vue&type=style&index=0&id=2d84a836&scoped=true&lang=css"
import "@/assets/css/essayWriting.sass?vue&type=style&index=1&id=2d84a836&lang=sass&scoped=true"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d84a836"]])

export default __exports__